// Ported verbatim from native/src/editor/activity/plugins/challenge/MyStorybookFlow.js:121-130.

'use strict';

function evaluate (activityData, simState) {
    const pagesWithScripts = (simState && typeof simState.pagesWithScripts === 'number')
        ? simState.pagesWithScripts
        : 0;
    const minRequired = (activityData && activityData.successCriteria
        && activityData.successCriteria.minPagesWithScripts) || 2;
    const projectRun = Boolean(simState && simState.projectHasRun);

    return {
        pagesWithScripts,
        minRequired,
        projectRun,
        success: pagesWithScripts >= minRequired && projectRun
    };
}

module.exports = evaluate;
